import * as fromDatatype from "../datatype-library/index";

export interface bl_cms_calendar_event_notification_queue_RowInterface{
    guid: fromDatatype.GuidDataFieldInterface;
    guid_calendar_event_hdr: fromDatatype.GuidDataFieldInterface;
    calendar_hdr_guid: fromDatatype.GuidDataFieldInterface;
    event_message: fromDatatype.VarcharDatatypeInterface;
    event_code: fromDatatype.VarcharDatatypeInterface;
    number_of_retry: fromDatatype.IntegerDatatypeInterface;
    max_retry: fromDatatype.IntegerDatatypeInterface;
    start_date: fromDatatype.TimestampTzDatatypeInterface;
    end_date: fromDatatype.TimestampTzDatatypeInterface;
    initial_planned_execute_time: fromDatatype.TimestampTzDatatypeInterface;
    event_properties: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_cms_calendar_event_notification_queue_RowClass implements bl_cms_calendar_event_notification_queue_RowInterface{
    guid: fromDatatype.GuidDataFieldInterface;
    guid_calendar_event_hdr: fromDatatype.GuidDataFieldInterface;
    calendar_hdr_guid: fromDatatype.GuidDataFieldInterface;
    event_message: fromDatatype.VarcharDatatypeInterface;
    event_code: fromDatatype.VarcharDatatypeInterface;
    number_of_retry: fromDatatype.IntegerDatatypeInterface;
    max_retry: fromDatatype.IntegerDatatypeInterface;
    start_date: fromDatatype.TimestampTzDatatypeInterface;
    end_date: fromDatatype.TimestampTzDatatypeInterface;
    initial_planned_execute_time: fromDatatype.TimestampTzDatatypeInterface;
    event_properties: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    
}